export default __webpack_public_path__ + "static/media/tranings_no_image_1.83d2e34f.svg";